module.exports = __webpack_public_path__ + "static/img/menage4.85855c12.jpg";